const LoginCircle02Icon = /*#__PURE__*/ [
  ["path", { d: "M12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M13 8C13 8 9.00001 10.946 9 12C8.99999 13.0541 13 16 13 16M9.5 12H21", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export { LoginCircle02Icon as default };
//# sourceMappingURL=LoginCircle02Icon.js.map
